import { render } from "./AddFoodView.vue?vue&type=template&id=0b8241a5"
import script from "./AddFoodView.vue?vue&type=script&lang=js"
export * from "./AddFoodView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__